import { makeStyles } from "@material-ui/core/styles";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import { RefObject, useEffect, useState } from "react";
import { User, UserForRanking } from "../../../../../../../shared/User/types";
import { BasicRanking } from "../../../../../../zApps/parts/Ranking/LevelRanking/BasicRanking/BasicRanking";
import { InitialView } from "../../../MyPageTop/types";
import { OpenableCard } from "../OpenableCard";

export function RankingAroundMe({
    user: player,
    initialView,
    scrollableContainerRef,
}: {
    user: User;
    initialView?: InitialView;
    scrollableContainerRef: RefObject<HTMLDivElement>;
}) {
    const [users, setUsers] = useState<UserForRanking[]>([]);
    const [myRank, setMyRank] = useState(0);
    const [initialRank, setInitialRank] = useState<number | undefined>(
        undefined
    );
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchUsersAroundMyRank(player.userId).then(
            ({ users: _users, myRank: _myRank }) => {
                let playerIndex = _users.findIndex(
                    u => u.userId === player.userId
                );
                if (playerIndex < 0) {
                    // If many players' XP is the same, there's a possibility that the array doesn't include the player.
                    // Even when everyone's XP is the same, insert the player in the middle.
                    _users.splice(10, 0, player).sort((a, b) => b.xp - a.xp);
                    playerIndex = _users.findIndex(
                        u => u.userId === player.userId
                    );
                }
                setUsers(_users);
                setMyRank(_myRank);
                setInitialRank(_myRank - playerIndex);
            }
        );
    }, [player]);

    const c = useStyles();

    return (
        <OpenableCard
            title={
                myRank && (
                    <span>
                        Ranking: <span className={c.titleNumber}>{myRank}</span>
                    </span>
                )
            }
            icon={<TrendingUpIcon />}
            saveKey="MyPageUserRankingAroundMe"
            id="MyPageUserRankingAroundMe"
            open={open}
            setOpen={setOpen}
            alwaysShowIcon
            alwaysShowTitle
            initiallyOpenedId={initialView}
            scrollableContainerRef={scrollableContainerRef}
        >
            <div className={c.container}>
                <div className={c.rankingWrapper}>
                    <BasicRanking
                        users={users}
                        player={player}
                        initialRank={initialRank}
                        collapseOpen={open}
                        style={{ height: 308 }}
                    />
                </div>
            </div>
        </OpenableCard>
    );
}
const useStyles = makeStyles(theme => ({
    container: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
    },
    titleNumber: { color: theme.palette.success.dark },
    rankingWrapper: {
        width: "100%",
    },
}));

async function fetchUsersAroundMyRank(
    userId: number
): Promise<{ users: UserForRanking[]; myRank: number }> {
    const res = await fetch(`api/User/GetUsersAroundMyRank?userId=${userId}`);
    return res.json();
}
